import { type PropsWithChildren } from 'react';
import { cva } from 'class-variance-authority';

import { useSearchResultCardContext } from './SearchResultCardProvider';

import styles from './SearchResultCardContent.module.css';

const contentVariants = cva(styles.content, {
  variants: {
    variant: {
      default: styles.defaultContent,
      preview: styles.previewContent,
    },
  },
});

export const SearchResultCardContent = ({ children }: PropsWithChildren) => {
  const { isApproximateLocation, preferences, variant } = useSearchResultCardContext();

  return (
    <div
      className={contentVariants({ variant })}
      data-has-preference-score={Boolean(preferences)}
      data-is-approximate-location={isApproximateLocation}
    >
      {children}
    </div>
  );
};
